import { memo } from "react";
import { Invoice, InvoiceSource } from "@common/types/invoice";
import { AccountCard } from "@components/financialAccount/AccountCard/AccountCard";
import { EmptyValue } from "@design-system/EmptyValue/EmptyValue";
import { KickAccountCard } from "./KickAccountCard";
import { QuickbooksAccountCard } from "./QuickbooksAccountCard";

export const InvoiceAccountContent = memo(
    ({ invoice }: { invoice?: Invoice }) => {
        if (invoice?.source === InvoiceSource.MANUAL) {
            return <KickAccountCard />;
        }
        if (invoice?.financialAccount) {
            return (
                <AccountCard
                    account={invoice.financialAccount}
                    onlyNumber
                    showType={false}
                    iconSize="xs"
                />
            );
        }
        if (invoice?.source === InvoiceSource.QUICKBOOKS) {
            return <QuickbooksAccountCard />;
        }
        return <EmptyValue />;
    },
);
InvoiceAccountContent.displayName = "InvoiceAccountContent";
